import script from "./EmptyTeamGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmptyTeamGuide.vue?vue&type=script&lang=ts&setup=true"

import "./EmptyTeamGuide.vue?vue&type=style&index=0&id=73c1327c&lang=scss&scoped=true"

import exportComponent from "/home/deploy/www/data/workspace/ads_tencn-prod/ads/src/grow-team-assist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c1327c"]])

export default __exports__